import { createSlice } from '@reduxjs/toolkit';
import i18n from "i18next";
// utils
import axios from 'utils/axios';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';

import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  fusions: [],
  filters: {
    name: '',
    groupbyname: true,
    groupbybirthplace: false,
    groupbyfirstname: true,
    groupbybirthdate: true

  },
  selected: {},
  saveSuccess: false,
  errorMessage: '',
  checkSuccess: false,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  }

};

const slice = createSlice({
  name: 'fusions',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET fusions
    getFusionsSuccess(state, action) {
      state.isLoading = false;
      state.error = null;
      state.fusions = action.payload;
    },
    saveFusionsSuccess(state) {
      state.isLoading = false;
      state.saveSuccess = true;
    },

    checkSuccess(state) {
      state.checkSuccess = true;
      state.isLoading = false;
    },

    reinitCheckSuccess(state) {
      state.checkSuccess = initialState.checkSuccess;
    },

    saveErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },

    //  SORT & FUSION fusions
    sortByFusions(state, action) {
      state.sortBy = action.payload;
    },
    //  SORT & FUSION fusions
    filterFusions(state, action) {
      state.filters = action.payload;
    },
    changeSelected(state, action) {
      state.selected = action.payload;
    },
    resetFusions(state) {
      state.fusions = initialState.fusions;
      state.filters = initialState.filters;
      state.selected = initialState.selected;
      state.saveSuccess = initialState.saveSuccess;
      state.error = initialState.error;
      state.errorMessage = initialState.errorMessage;
      state.checkSuccess = initialState.checkSuccess;
      state.navig = initialState.navig;

    },
    resetFusionsLight(state) {
      state.fusions = initialState.fusions;
      state.selected = initialState.selected;
      state.navig = initialState.navig;

    },
    //   pagination Users
    paginationFusions(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  filterFusions,
  resetFusions,
  resetFusionsLight,
  hasError,
  changeSelected,
  reinitCheckSuccess,
  paginationFusions
} = slice.actions;

// ----------------------------------------------------------------------

export function getFusions() {
  const { fusion: { fusions, filters, navig }, all: { config } } = store.getState();
  const emptyFilter = {
    ...{
      groupbyname: false,
      groupbybirthplace: false,
      groupbyfirstname: false,
      groupbybirthdate: false
    }
  };
  return async () => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.saveErrorMessage(''));
    try {
      if (JSON.stringify(filters) === JSON.stringify(emptyFilter))
        throw new Error('NOCRITERES');
      const response = await axios.post(API.path, {
        fusion: filters,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.LOADFUSION
      });
      const { data: { fusions: dataFusions, statut, reason } } = response;
      dispatch(slice.actions.stopLoading());

      if (statut === "ERROR") {
        if (reason === "NOCRITERES")
          throw new Error('NOCRITERES');

      }

      if (dataFusions.length === 0 && navig.nav_position === 0) {
        throw new Error('NO_RESULTS');
      } else if (dataFusions.length === 0 && navig.nav_position > 0) {
        dispatch(paginationFusions(navig.nav_position - 1));

      } else if (dataFusions.length > 0) {
        dispatch(slice.actions.getFusionsSuccess([...fusions, ...dataFusions]));
        dispatch(slice.actions.changeSelected(initialState.selected));
      }

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function checkBeforeFusions() {
  const { fusion: { selected } } = store.getState();
  let errorMessage = '';
  let notEmptyObject = 0;

  return async () => {
    try {

      Object.values(selected).forEach((item) => {
        if (item.oldIpp?.length > 0) {
          if (!item.newIpp) {
            if (item.oldIpp.length > 1) {
              errorMessage += `${'<p>'}${i18n.t(`merge.errors.NO_TARGET_IPP.message2`)}${item.oldIpp.reduce((acc, oldIpp) => `${acc}${oldIpp.oldIpp}, `, '').slice(0, -2)}${'.</p><br>'}`;
              notEmptyObject = + notEmptyObject + 1;
            } else {
              errorMessage += `${'<p>'}${i18n.t(`merge.errors.NO_TARGET_IPP.message1`)}${item.oldIpp[0].oldIpp}${'.</p><br>'}`;
              notEmptyObject = + notEmptyObject + 1;
            }
          } else {
            notEmptyObject = + notEmptyObject + 1;
          }
        } else if (item.newIpp) {
          errorMessage += `${'<p>'}${i18n.t(`merge.errors.NO_IPP_TO_MERGE.message`)}${item.newIpp}${'.</p><br>'}`;
          notEmptyObject = + notEmptyObject + 1;

        }
      });
   

      dispatch(slice.actions.saveErrorMessage(errorMessage.slice(0, -4)));

      if (notEmptyObject === 0)
        throw new Error('NO_IPP');

      if (errorMessage !== '') {
        throw new Error('NO_TARGET_IPP');
      }

      dispatch(slice.actions.checkSuccess());

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function saveFusions() {
  const { fusion: { selected } } = store.getState();
  const emptySelected = { ...initialState.selected };
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if (JSON.stringify(selected) === JSON.stringify(emptySelected))
        throw new Error('NO_TARGET_IPP');

      const array = [];
      Object.values(selected).map((item) => item?.oldIpp.map((old) => array.push({ "oldipp": old.oldIpp, "newipp": item.newIpp })));
      await axios.post(API.path, {
        fusions: array,
        action: ACTIONS.SAVEFUSION
      });
      dispatch(slice.actions.saveFusionsSuccess());

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

